export default __webpack_public_path__ + "media/images/casatb/tenant/timeline-four-087798cd5df4b6e374d1c7c2d06d0c74.png";